"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Spacer = styled_components_1.default.div.attrs({
    className: "Spacer",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  min-height: ", ";\n"], ["\n  height: ", ";\n  min-height: ", ";\n"])), function (props) {
    return (props.size === "xxxl" && "6.4rem") ||
        (props.size === "xxl" && "4.8rem") ||
        (props.size === "xl" && "3.2rem") ||
        (props.size === "l" && "2.4rem") ||
        (props.size === "m" && "1.6rem") ||
        (props.size === "s" && "0.8rem") ||
        (props.size === "xs" && "0.4rem") ||
        (props.size === "xxs" && "0.2rem") ||
        "1.6rem";
}, function (props) {
    return (props.size === "xxxl" && "6.4rem") ||
        (props.size === "xxl" && "4.8rem") ||
        (props.size === "xl" && "3.2rem") ||
        (props.size === "l" && "2.4rem") ||
        (props.size === "m" && "1.6rem") ||
        (props.size === "s" && "0.8rem") ||
        (props.size === "xs" && "0.4rem") ||
        (props.size === "xxs" && "0.2rem") ||
        "1.6rem";
});
var templateObject_1;
